exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/core-js/modules/_object-gops.js
// module id = 203
// module chunks = 1